import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { SettingsService } from '../../service/settings.service';
import { CommentsService } from '../../service/comments.service';
import { MatDialog } from '@angular/material/dialog';
import { deepCopy, getSizeBytes } from 'na-lib';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FileHandle } from '../../directive/drag-and-drop.directive';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MediaInsideFolderData } from '../../shared/media';
import { StorageService } from '../../service/storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-media-folder-content',
    templateUrl: './media-folder-content.component.html',
    styleUrls: ['./media-folder-content.component.css'],
    standalone: false
})

export class MediaFolderContentComponent implements OnDestroy {
  storage:any=[]
  storageMedia:any={
    items:[],
    folder: []
  }
  storageItems:any={
    items:[],
    folder: []
  }

  storagePassDefinitions:any=[]
  storageWorkTasks:any=[]
  storagePasses:any=[]
  panelOpenState = false;
  routerUrl:any
  idToShow:any
  currentRoute:any
  isDragOver = false;
  folder:any = []
  folderRoute:any
  newImage:any
  gridView = true
  gridViewOption = 'item'
  @Input() data: MediaInsideFolderData
  displayedColumns: string[] = ['icon','name','type', 'updated', 'size', 'actions'];
  listdata= new MatTableDataSource()
  @ViewChild('gridPaginator') gridPaginator: MatPaginator;
  @ViewChild('listPaginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  paginatorSize = this.settingsService.paginator$
  filteredFolder:any = []
  gridPagedFolder:any = []
  emptyMedia = false
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private settingsService: SettingsService,
    private commentService: CommentsService,
    private translate: TranslateService,
    public dialog: MatDialog,
    public storageService: StorageService
    ){
      this.routerUrl=this.route.url
      this.idToShow=this.routerUrl.value[this.routerUrl.value.length-1]?.path
      this.currentRoute=this.routerUrl.value[0]?.path
    }

  ngOnInit():void{
    this.folderRoute=""
    this.storage = []
    this.storageItems.items = []
    this.storageMedia.items = []

    if(this.data.folderItems){
      this.commentService.progressSpin.emit(true)

        if(this.data.folderItems.length ==  0)
          this.emptyMedia = true
        else
          this.emptyMedia = false
        this.folder = this.data.folderItems
        this.filteredFolder = deepCopy(this.data.folderItems)
        this.gridPagedFolder = this.filteredFolder.slice(0, this.paginatorSize[0])
        const items = deepCopy(this.data.folderItems)
        items.forEach(file => {
          if(!file.folder){
            if(file.metadata){
              file.size = file.metadata?.size
              file.updated = file.metadata?.updated
              file.type = file.metadata?.contentType
            }
          }
        });
        this.listdata = new MatTableDataSource(items);
        this.shorTableAgain()

      this.commentService.progressSpin.emit(false)

      this.storageService.watchVideoThumbnails(this.data.folderItems);
      this.storageService.videoThumbReady$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateGridPage();
      });

      this.storageService.watchImageThumbnails(this.data.folderItems);
      this.storageService.imageThumbReady$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateGridPage();
      });
    }

    if(this.data.view){
      const view = this.data.view
      this.gridViewOption = view
      switch(view){
        case 'list': {
          this.gridView = false
          // this.data.setViewStyle('list')
          break;
        }

        case 'item': {
          this.gridView = true
          // this.data.setViewStyle('item')
          break;
        }
      }
    }
  }

  ngAfterViewInit(): void {
    this.listdata.paginator = this.paginator;
    this.listdata.sort = this.sort;
    if (this.gridPaginator) {
      this.gridPaginator.page.subscribe(() => this.updateGridPage());
    }
  }

  shorTableAgain(){
    this.listdata.paginator = this.paginator;
    this.listdata.sort = this.sort;
    setTimeout(() => {
      this.listdata.filter = " ";
    this.commentService.progressSpin.emit(false)
      this.updateGridPage();
    }, 500);
  }

  updateGridPage(): void {
    if (!this.gridPaginator) {
      this.gridPagedFolder = this.filteredFolder;
      return;
    }
    const pageSize = this.gridPaginator.pageSize || this.paginatorSize[0];
    const pageIndex = this.gridPaginator.pageIndex || 0;
    const start = pageIndex * pageSize;
    this.gridPagedFolder = this.filteredFolder.slice(start, start + pageSize);
  }

  // trackBy for performance in ngFor
  trackByName(_: number, item: any) {
    return item?.name || item?.folder || item?.item || item?.url;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    if(!filterValue.trim().toLocaleLowerCase())
      this.filteredFolder =  deepCopy(this.folder)
    else
      this.filteredFolder = this.filteredFolder.filter( file => file.name.toLocaleLowerCase().includes(filterValue.trim().toLocaleLowerCase()))

    this.listdata.filter = filterValue.trim().toLowerCase();

    if (this.paginator) {
      this.paginator.firstPage();
    }
    if (this.gridPaginator) {
      this.gridPaginator.firstPage();
    }
    this.updateGridPage();
  }

  triggerFileInput() {
    document.getElementById('myfile-upload-media')?.click();
  }

  readURL(event:any){
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      this.data.addFileToFolder(file.file, this.folder.length)
    }
  }

  changeView( view){
    switch(view){
      case 'list': {
        this.gridView = false
        this.data.setViewStyle('list')
        break;
      }

      case 'item': {
        this.gridView = true
        this.data.setViewStyle('item')
        break;
      }
    }
  }

  checkFileType(file){
    let type

    if(file.folder)
      type = 'folder'
    if(file.metadata){
      if(file.metadata?.contentType === 'application/pdf')
        type = 'file'

      if(file.metadata?.contentType.startsWith('image'))
        type = 'image'


      if(file.metadata?.contentType.startsWith('video') )
        type = 'video'

      if(!file.metadata?.contentType.startsWith('image') && !file.metadata?.contentType.startsWith('video'))
        type='file'

    }else{

    }

    return type
  }


  getFileSize(size){
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    if(size)
    return getSizeBytes(size,units ,2)
    else
    return undefined
  }

  openFilePreview(file){
    this.data.openFilePreview(file)
  }

  downloadFile(file){
    this.data.downloadFile(file)
  }

  deleteFile(file){
    this.data.deleteFile(file)
  }

  async filesDropped(files: FileHandle[]): Promise<void> {
    files.forEach( async (file, index) => {
      this.data.addFileToFolder(file.file, index)
    })
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;

    if (event.dataTransfer?.files?.length) {
      const files = Array.from(event.dataTransfer.files);
      files.forEach((f, i) => this.data.addFileToFolder(f, i));
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.storageService.unsubscribeVideoThumbnails();
    this.storageService.unsubscribeImageThumbnails();
  }

}
